/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { format } from 'date-fns';
import { Typography } from '@material-ui/core';
import { Card, Chip, Grid } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TabPanel from '@mui/lab/TabPanel';
import IncidentTable from './IncidentTable';
import useStyles from './styles';
import { getClient, getInstanceRunningStatus } from '../../redux/Actions/clientInfo.action';

export default function Client() {
    const classes = useStyles();
    const dispatch = useDispatch();

    const clientInfo = useSelector((state) => state.clientReducer.clientInfo);
    const runningStatus = useSelector((state) => state.clientReducer.instanceRunningStatus);
    const [value, setValue] = useState('current');
    const [serviceStatus, setServiceStatus] = useState(true);
    const [lastLogin, setLastLogin] = useState('');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [svalues, setSvalues] = useState([]);

    useEffect(() => {
        svalues.forEach((val) => {
            if (val.status === 'Performance Degraded') {
                setServiceStatus(false);
            }
        });
    }, [svalues]);

    useEffect(() => {
        const tenantId = Cookies.get('tenantId');
        dispatch(getClient(tenantId));
        const lastLoginCookie = Cookies.get('lastLogin');
        if (lastLoginCookie) {
            setLastLogin(lastLoginCookie);
        }
    }, []);

    useEffect(() => {
        dispatch(getInstanceRunningStatus(clientInfo.hostname));
    }, [clientInfo, dispatch]);

    useEffect(() => {
        setSvalues(runningStatus);
    }, [runningStatus]);

    return (
        <>
            {' '}
            <div className={classes.mainBody}>
                <div className={classes.bodyContainer}>
                    <div className={classes.backSet}>
                        <Grid container>
                            <Grid item xs={12} sm={5} md={3}>
                                <div className={classes.leftContainer}>
                                    <Typography variant="subtitle1" className={classes.frstHead}>
                                        {clientInfo.name}
                                    </Typography>
                                    {lastLogin &&
                                        Number.isNaN(new Date(lastLogin).getTime()) === false && (
                                            <Typography
                                                variant="subtitle1"
                                                className={classes.timeHead}
                                            >
                                                Last Login:{' '}
                                                {format(new Date(lastLogin), 'yyyy-M-dd HH:mm:ss')}
                                            </Typography>
                                        )}
                                    <div className={classes.linColor}>
                                        {serviceStatus === true ? (
                                            <Card className={classes.leftCardCheck}>
                                                <div className={classes.cardMsg}>
                                                    <CheckCircleIcon className={classes.warnIcon} />
                                                    <Typography
                                                        variant="subtitle1"
                                                        className={classes.performText}
                                                    >
                                                        {' '}
                                                        All services are working fine{' '}
                                                    </Typography>
                                                </div>
                                            </Card>
                                        ) : (
                                            <Card className={classes.leftCard}>
                                                <div className={classes.cardMsg}>
                                                    <WarningIcon className={classes.warnIcon} />
                                                    <Typography
                                                        variant="subtitle1"
                                                        className={classes.performText}
                                                    >
                                                        {' '}
                                                        Performance Degraded{' '}
                                                    </Typography>
                                                </div>
                                            </Card>
                                        )}
                                    </div>
                                    <div className={classes.serviceAlign}>
                                        <Typography
                                            style={{ fontSize: '13px' }}
                                            variant="subtitle2"
                                        >
                                            Services
                                        </Typography>
                                        <Typography
                                            style={{ fontSize: '13px' }}
                                            variant="subtitle2"
                                            className={classes.statusAlign}
                                        >
                                            Status
                                        </Typography>
                                    </div>
                                    {svalues.length > 0 &&
                                        svalues.map((value, idx) => (
                                            <>
                                                <div key={idx} className={classes.serviceheadAlign}>
                                                    <Typography
                                                        variant="subtitle1"
                                                        className={classes.servicename}
                                                    >
                                                        {value.name.replace('-', ' ')}
                                                    </Typography>
                                                    {value.status === 'Operational' ? (
                                                        <Chip
                                                            title={value.status}
                                                            label={value.status}
                                                            className={classes.chipStyle}
                                                        />
                                                    ) : (
                                                        <Chip
                                                            title={value.status}
                                                            label={value.status}
                                                            className={classes.chipStyleTwo}
                                                        />
                                                    )}
                                                </div>
                                            </>
                                        ))}
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={7} md={9}>
                                <div className={classes.rightContainer}>
                                    <Box sx={{ width: '100%', typography: 'body1' }}>
                                        <TabContext value={value}>
                                            <Box
                                                sx={{
                                                    borderBottom: 1,
                                                    borderColor: 'divider',
                                                    margin: '0px 22px'
                                                }}
                                            >
                                                <TabList
                                                    onChange={handleChange}
                                                    aria-label="lab API tabs example"
                                                >
                                                    <Tab
                                                        className={classes.tabLabel}
                                                        label="CURRENT INCIDENTS"
                                                        value="current"
                                                    />
                                                    <Tab
                                                        className={classes.tabLabel}
                                                        label="PAST INCIDENTS"
                                                        value="past"
                                                    />
                                                </TabList>
                                            </Box>
                                            <TabPanel value="current">
                                                <div className={classes.dataShow}>
                                                    <IncidentTable
                                                        tab={value}
                                                        value="No incidents logged to show"
                                                    />
                                                </div>
                                            </TabPanel>
                                            <TabPanel value="past">
                                                <div className={classes.dataShow}>
                                                    <IncidentTable
                                                        tab={value}
                                                        value="No incidents logged to show"
                                                    />
                                                </div>
                                            </TabPanel>
                                        </TabContext>
                                    </Box>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </div>
        </>
    );
}
